import React, { useState, createRef, useEffect } from "react";
import { colors } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link, useNavigate } from "react-router-dom";
import YupupScreen from "./../../../assets/icons/LogoScreen.svg";
import { Form, Input as InputField, message } from "antd";
import {
  changePassword,
  confirmPassword,
  forgotPassword,
} from "../../../api/auth";

const NewPassword = ({ invite }) => {
  const [form] = Form.useForm();
  const email = localStorage.getItem("forgotPasswordEmail");
  const inviteEmail = localStorage.getItem("inviteEmail");
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState(Array(6).fill(""));
  const inputRefs = Array(6)
    .fill(null)
    .map(() => createRef());
  const [loader, setLoader] = useState(false);

  const onFinish = async (values) => {
    setLoader(true);

    if (invite) {
      const payload = {
        email: inviteEmail,
        currentPassword: values.currentPassword,
        newPassword: values.password,
      };
      try {
        const res = await changePassword(payload);
        if (res?.success) {
          message.success("Password Changed");
          navigate("/login");
        }
      } catch (error) {
        message.error(error);
      } finally {
        setLoader(false);
      }
    } else {
      const input = inputValues.join("");
      const payload = {
        email: email,
        confirmationCode: input,
        newPassword: values.password,
      };
      try {
        const res = await confirmPassword(payload);
        if (res?.status) {
          message.success("Password Changed");
          navigate("/reset");
        }
      } catch (error) {
        message.error(error);
      } finally {
        setLoader(false);
      }
    }
  };

  const handleResendCode = async () => {
    const payload = {
      email: email,
    };
    const res = await forgotPassword(payload);
    if (res) {
      message.success("Sent");
    }
  };

  const handleKeyDown = (index, event) => {
    const keyCode = event.keyCode || event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
      event.preventDefault();
    } else if (
      keyCode === 8 &&
      index > 0 &&
      inputRefs[index].current.value === ""
    ) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleInput = (index, event) => {
    const input = event.target;
    const inputValue = input.value;

    if (inputValue.length === 1 && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const newInputValues = [...inputValues];
    newInputValues[index] = inputValue;
    setInputValues(newInputValues);

    if (inputValue === "" && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };
  useEffect(() => {
    if (!email && !inviteEmail) {
      navigate("/login");
    }
  }, [email, inviteEmail, navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-screen ">
      <div className="object-cover">
        <img
          className="block h-12 xl:h-15.3 xl:w-26.9"
          alt="yupup-screen-logo"
          src={YupupScreen}
        />
      </div>
      <div className="flex flex-col text-center">
        <p className="text-heading lg:text-xl font-bold">
          Set The New Password
        </p>
        <Form
          form={form}
          name="myForm"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <div className="w-31 sm:w-full lg:space-y-2">
            <Form.Item
              name={invite ? "currentPassword" : "password"}
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <InputField.Password
                className={"w-31 h-5.4 sm:w-full"}
                placeholder={invite ? "Current Password" : "Password"}
              />
            </Form.Item>
            <p className="text-start text-grey">
              Must be at least 6 characters
            </p>
            <Form.Item
              className=""
              name={invite ? "password" : "confirmpassword"}
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The new password that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <InputField.Password
                className={"w-31 h-5.4 sm:w-full"}
                placeholder={invite ? "New Password" : "Confirm Password"}
              />
            </Form.Item>

            {invite ? (
              ""
            ) : (
              <div className="my-2">
                <p className="text-start text-grey">
                  Please enter OTP sent to your phone number:
                </p>
                <div className="grid grid-cols-6 gap-3 w-31 sm:w-full">
                  {inputRefs.map((ref, index) => (
                    <InputField
                      ref={ref}
                      key={index}
                      className="w-5 h-6  text-center text-lg"
                      placeholder=""
                      maxLength={1}
                      onKeyDown={(event) => handleKeyDown(index, event)}
                      onInput={(event) => handleInput(index, event)}
                    />
                  ))}
                </div>
                <div
                  onClick={handleResendCode}
                  className="text-primaryPurple cursor-pointer mt-2"
                >
                  Resend Code
                </div>
              </div>
            )}

            <Form.Item>
              <Button
                loading={loader}
                className="w-31 sm:w-full"
                title="Reset Password"
                color={colors.primaryPurple}
                htmlType="submit"
              />
            </Form.Item>
          </div>
        </Form>
        <Link to="/login" className="no-underline lg:mt-5">
          <span className="text-grey ">Back to Login</span>
        </Link>
      </div>
    </div>
  );
};

export default NewPassword;
